import { render, staticRenderFns } from "./event-modal.vue?vue&type=template&id=c136b3b6"
import script from "./event-modal.vue?vue&type=script&lang=js"
export * from "./event-modal.vue?vue&type=script&lang=js"
import style0 from "./event-modal.vue?vue&type=style&index=0&id=c136b3b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports